export async function ortaklariListele(istemci, sayfa = 1, boyut = 50) {
    return istemci.istek(`/ortaklar?sayfa=${sayfa}&boyut=${boyut}`);
}
export async function ortakGetir(istemci, id) {
    return istemci.istek(`/ortaklar/${id}`);
}
export async function ortakOlustur(istemci, giris) {
    return istemci.istek('/ortaklar', {
        method: 'POST',
        body: JSON.stringify(giris),
    });
}
export async function ortakGuncelle(istemci, id, giris) {
    return istemci.istek(`/ortaklar/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(giris),
    });
}
export async function ortakSil(istemci, id) {
    return istemci.istek(`/ortaklar/${id}`, { method: 'DELETE' });
}
export async function ortakNoktaAta(istemci, ortakId, giris) {
    return istemci.istek(`/ortaklar/${ortakId}/nokta-ata`, {
        method: 'POST',
        body: JSON.stringify(giris),
    });
}
export async function ortakNoktaCikar(istemci, ortakId, noktaId) {
    return istemci.istek(`/ortaklar/${ortakId}/noktalar/${noktaId}`, {
        method: 'DELETE',
    });
}
export async function hakedisRaporuGetir(istemci, sorgu) {
    const p = new URLSearchParams();
    p.set('baslangic', sorgu.baslangic);
    p.set('bitis', sorgu.bitis);
    if (sorgu.ortakId)
        p.set('ortakId', sorgu.ortakId);
    return istemci.istek(`/ortaklar/hakedis?${p.toString()}`);
}
//# sourceMappingURL=ortaklar.js.map